// src/routes/platformRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import platformRoutesConfig from './config/platformRoutesConfig';

// Platform super-admin only — never Admin, so cross-org data stays off tenant roles.
const PlatformRoutes = platformRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['Platform']} />
      </Suspense>
    }
  />
));
export default PlatformRoutes;
